
<script>
import New from './New13'
import Edit from '../Edit'
export default {
  mixins: [New, Edit],
}
</script>
